
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from '../components/explanations/linking-words-explanation';
const mainimage = '/Images/linkingwords1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "linkingwords" },
];

const LinkingWords = () => (
  <GrammarPageLayout
    level="B1"
    title="Linking Words"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Linking Words Exercises"
    seoDescription="Connect ideas smoothly with conjunctions and discourse markers. C1 level exercises."
    relatedCategory="grammar-exercises"
    relatedLevel="C1"
  />
);

export default LinkingWords;

